import { apiSlice } from "../../api/apiSlice";

export const dateWiseEnergyConsumptionApi = apiSlice.injectEndpoints({
  // tagTypes: ["Bill"],
  endpoints: (builder) => ({
    // getAllBillList: builder.query({
    //   query: () => "/apiV2/energy-meter/bill-info",
    //   providesTags: ["Bill"],
    // }),

    dailyEnergyConsumption: builder.mutation({
      query: (data) => ({
        url: "/apiV2/energy-meter/daily-consumption",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: ["Total-Bill"],
    }),
    hourlyEnergyConsumption: builder.mutation({
      query: (data) => ({
        url: "/apiV2/energy-meter/daily_hourly-energy-consumption",
        method: "POST",
        body: data,
      }),
      // invalidatesTags: ["Total-Bill"],
    }),
    // acrelBillUpdate: builder.mutation({
    //   query: (data) => ({
    //     url: "/apiV2/energy-meter/bill-update",
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: ["Bill"],
    // }),
    // deleteBill: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `/apiV2/energy-meter/bill-destroy?id=${id}`,
    //     method: "DELETE",
    //     // body: data,
    //   }),
    //   invalidatesTags: ["Bill"],
    // }),
  }),
});

export const {
  // useGetAllBillListQuery,
  useDailyEnergyConsumptionMutation,
  useHourlyEnergyConsumptionMutation,
  // useAcrelBillUpdateMutation,
  // useDeleteBillMutation,
} = dateWiseEnergyConsumptionApi;
